/** Which routes have a redone page in the new design. App.tsx shows it to people on the new design and the
 *  classic page to everyone else. Each group lists its own pages in its own file, so the groups can be
 *  built side by side without touching each other's files. Keys are App.tsx route paths, exactly. */
import type { ComponentType } from "react";

import { adminPages } from "./admin/routes";
import { moneyPages } from "./money/routes";
import { paperworkPages } from "./paperwork/routes";
import { salesPages } from "./sales/routes";
import { stockPages } from "./stock/routes";

export const nextPages: Record<string, ComponentType> = { ...stockPages, ...salesPages, ...moneyPages, ...paperworkPages, ...adminPages };
